<template>
 <div id="speecher">
    <div class="ys-float-btn" :style="{'right':0,'top':top+'px'}"
       ref="div">
      <template v-if="isPlaying">
        <van-icon
         v-if="!speechPause"
          class="circle-breath"
          name="pause"
          size="20"
          @click="pauseSpeech" />
        <van-icon
          v-if="speechPause"
          size="20"
          name="play"
          @click="pauseSpeech"/>
        <van-icon name="stop" @click="resetSpeech" />
      </template>
       <template v-else>
        <van-image :src="playImg" @click="playSpeech"/>
        <!-- <div class="font-wapper">
          <p>语音</p>
          <p>播报</p>
        </div> -->
      </template>
    </div>
 </div>
</template>

<script>

  export default {
    name: "FloatImgBtn",
    props:{
      text:{
        type:String,
        default:"默认文字"
      },
      itemWidth:{
        type:Number,
        default:60
      },
      itemHeight:{
        type:Number,
        default:60
      },
      gapWidth:{
        type:Number,
        default:10
      },
      coefficientHeight:{
        type:Number,
        default:0.8
      },
      speechPause: {
        type:Boolean,
        default:false
      }
    },
    data(){
      return{
        timer:null,
        currentTop:0,
        clientWidth:0,
        clientHeight:0,
        right:0,
        top:0,
        playImg: require("../../assets/speech/laba.png"),
        isPlaying: false
      }
    },
    created(){
      //console.log('iro', this.speechPause)
      this.clientWidth = document.documentElement.clientWidth;
      this.clientHeight = document.documentElement.clientHeight;
      this.right = 0;
      this.top = 30;
    },
    mounted(){
      window.addEventListener('scroll', this.handleScrollStart);
      this.$nextTick(()=>{
        const div = this.$refs.div;
        div.addEventListener("touchstart",()=>{
          div.style.transition = 'none';
        });
        div.addEventListener("touchmove",(e)=>{
          if (e.targetTouches.length === 1) {
            let touch = event.targetTouches[0];
            this.right = 0;
            this.top = touch.clientY - this.itemHeight/2;
          }
        });
        div.addEventListener("touchend",()=>{
          div.style.transition = 'all 0.3s';
        });

      });
    },
    beforeDestroy(){
      window.removeEventListener('scroll', this.handleScrollStart);
    },
    methods:{
      playSpeech() {
        //this.isPlaying = true
        this.$emit("playAudio")
      },
      pauseSpeech() {
        this.$emit("pauseAudio")
      },
      resetSpeech() {
        this.$emit("resetAudio")
      },
      onBtnClicked(){
        this.$emit("onFloatBtnClicked");
      },
      handleScrollStart(){
        this.timer&&clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
          this.handleScrollEnd();
        },300);
        this.currentTop = document.documentElement.scrollTop || document.body.scrollTop;
        if(this.right>this.clientWidth/2){
          this.right = this.clientWidth - this.itemWidth/2;
        }else{
          this.right = -this.itemWidth/2;
        }
      },
      handleScrollEnd(){
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if(scrollTop === this.currentTop){
          if(this.right>this.clientWidth/2){
            this.right = this.clientWidth - this.itemWidth - this.gapWidth;
          }else{
            this.right = this.gapWidth;
          }
          clearTimeout(this.timer);
        }
      }
    }
  }
</script>


<style lang="less" scoped>
  .ys-float-btn{
    background:rgb(0,0,0,0.9);
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    color: #fff;
    z-index: 200;
    transition: all 0.3s;

    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 30px;
    right: 0;
    padding: 10px 5px 10px 10px;
    p{
      font-size:18px;
      display:none;
      padding: 0 5px 0 5px;
    }
    &:hover p {
      display:block;
    }
    .font-wapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    /deep/.van-image__img{
      object-fit: contain;
      margin-bottom: 3px;
      width: 50px;
      height: 50px;
    }
    .circle-breath {
      box-shadow: 0 0 0 0#E3F0FF;
      animation: donghua 1.5s infinite;
    }
    /deep/.van-icon-pause {
      background-color:#4387FB;
      border: 5px solid #D2DDEB;
      border-radius: 50%;
      padding: 10px;
      margin-right: 10px;
    }
    /deep/.van-icon-play {
      background-color:#4387FB;
      border: 5px solid #D2DDEB;
      border-radius: 50%;
      padding: 10px;
      margin-right: 10px;
    }
    /deep/.van-icon-stop {
      background-color:#5C5C5C;
      border-radius: 50%;
      padding: 8px;
    }
    @keyframes donghua {
      0% {
        box-shadow: 0 0 0 0 rgba(227, 240, 255, 100%);
      }

      60% {
        box-shadow: 0 0 0 20px rgba(227, 240, 255, 0%);
      }

      100% {
        box-shadow: 0 0 0 0 rgba(227, 240, 255, 0%);
      }
    }
  }
</style>
